/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PromptCodeModel } from '../../models/prompt-code-model';

export interface GetPromptCodes$Params {
  patientID?: number;
  onlyActive?: boolean;
}

export function GetPromptCodes(http: HttpClient, rootUrl: string, params?: GetPromptCodes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PromptCodeModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPromptCodes.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
    rb.query('onlyActive', params.onlyActive, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PromptCodeModel>>;
    })
  );
}

GetPromptCodes.PATH = '/api/Supervisor/GetPromptCodes';
